import React from "react"
import InsightPage from '../../components/Insight/InsightPage';
import TopImage from '../../images/Service-hero.jpg';

export default () => {
  return (
    <InsightPage slugParam={"five-exciting-off-premise-technologies-for-2021"}
    topImage={TopImage}
    />
  )};